export const PASSWORD_VALIDATION_MATCHING = "passwordMatch";
export const PASSWORD_VALIDATION_LENGTH = "atLeastEightChars";
export const PASSWORD_VALIDATION_UPPER_LOWER = "atLeastOneUpperLowerCase";
export const PASSWORD_VALIDATION_DIGIT = "atLeastOneDigit";
export const PASSWORD_VALIDATION_SPECIAL = "atLeastOneSpecialChar";
export const PASSWORD_VALIDATION_DISALLOWED = "avoidDisallowedChars";
export const PASSWORD_VALIDATION_NODASHBEGIN = "avoidDashBegin";



/** WEBPACK FOOTER **
 ** ./src/constants/PasswordStrength.js
 **/